<template>
  <transition name="msgbox-fade">
    <div class="pop-confirm-wrap" v-show="show">
      <div class="pop-confirm-content">
        <div class="close-icon" v-if="showClose">
          <i class="el-dialog__close el-icon el-icon-close activeIconHover" @click="cancel"></i>
        </div>
        <div class="title">
          <i class="el-message__icon el-icon-warning" v-if="type === 'warning'"></i>
          {{title}}
        </div>
        <div class="content" v-if="content" v-html="content">
        </div>
        <div class="btn-wrap">
          <span class="cancel text-btn-active" @click="cancel" >{{cancelText}}</span>
          <!-- <wf-button class="cancel" plain @click="cancel" style="margin-right:16px;">取消</wf-button> -->
          <wf-button :type="btnType === 'warning' ? 'danger' : 'primary'" @click="confirm">{{btnText}}</wf-button>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      type:'',
      title: '提示',
      content: '',
      btnText: '确定',
      cancelText: '取消',
      showClose: true,
      confirm: () => {},
      cancel: () => {}
    }
  }
}
</script>
<style lang="scss">
//确认弹窗样式
.pop-confirm-wrap {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  .pop-confirm-content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 362px;
    min-height: 153px;
    background: #fff;
    box-shadow: 0px 4px 16px 0px rgba(13, 31, 60, 0.16);
    border-radius: 4px;
    padding: 24px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .close-icon {
      position: absolute;
      right: 24px;
      top: 21px;
      width: 28px;
      height: 28px;
      display: flex;
      justify-content: center;
      align-items: center;
      // &:hover {
      //   background: rgba(32, 32, 32, 0.08);
      //   border-radius: 4px;
      // }
    }
    .el-icon-close {
      font-size: 14px;
      cursor: pointer;
    }
    .title {
      display: flex;
      align-items: center;
      font-size: 18px;
      font-weight: 500;
      color: #202020;
      line-height: 22px;
      padding-right: 24px;
      i {
        color: #FF3939;
        font-size: 20px;
        margin-right: 15px;
      }
    }
    .content {
      width: 100%;
      // min-height: 57px;
      margin: 36px 0;
      font-size: 14px;
      font-weight: 400;
      color: #202020;
      line-height: 18px;
      &.warning {
        padding-left: 30px;
      }
    }
    .btn-wrap {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .cancel {
        margin-right: 24px;
      }
    }
  }
}
</style>
